<template>
    <ubi-panel>
        <ubi-form-group :title="$t('posts.dpeTitle')">
            <el-row :gutter="20">
                <el-col :lg="9">
                    <el-form-item :label="$labels.dpe_valeur_conso"
                                  prop="dpe_valeur_conso">
                        <el-input   v-mask="'#################'" v-model.number="post.dpe_valeur_conso" type="dpe_valeur_conso">
                            <template slot="append">KWh/m²/an</template>
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="14">
                        <el-form-item>
                        <div style="font-size: 12px;">{{ $labels.dpe_etiquette_conso }} <el-button class="el-icon-error reset-radio"
                         v-if="post.dpe_etiquette_conso != '' && post.dpe_etiquette_conso != undefined && post.dpe_etiquette_conso != null"
                         @click="post.dpe_etiquette_conso = null"
                           circle></el-button></div>
                        <el-radio-group v-model="post.dpe_etiquette_conso">
                            <el-col :span="3"><el-radio label="A"></el-radio></el-col>
                            <el-col :span="3"><el-radio label="B"></el-radio></el-col>
                            <el-col :span="3"><el-radio label="C"></el-radio></el-col>
                            <el-col :span="3"><el-radio label="D"></el-radio></el-col>
                            <el-col :span="3"><el-radio label="E"></el-radio></el-col>
                            <el-col :span="3"><el-radio label="F"></el-radio></el-col>
                            <el-col :span="3"><el-radio label="G"></el-radio></el-col>
                        </el-radio-group>
                        </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :lg="9">
                    <el-form-item :label="$labels.dpe_valeur_ges"
                                  prop="dpe_valeur_ges">
                        <el-input   v-mask="'#################'" v-model.number="post.dpe_valeur_ges" prop="dpe_valeur_ges">
                            <template slot="append">CO2/m²/an</template>
                        </el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="14">
                    <el-form-item>
                         <div style="font-size: 12px;">{{ $labels.dpe_etiquette_ges }} <el-button class="el-icon-error reset-radio"
                         v-if="post.dpe_etiquette_ges != '' && post.dpe_etiquette_ges != undefined && post.dpe_etiquette_ges != null"
                         @click="post.dpe_etiquette_ges = null"
                           circle></el-button></div>
                        <el-radio-group v-model="post.dpe_etiquette_ges">
                            <el-col :span="3"><el-radio label="A"></el-radio></el-col>
                            <el-col :span="3"><el-radio label="B"></el-radio></el-col>
                            <el-col :span="3"><el-radio label="C"></el-radio></el-col>
                            <el-col :span="3"><el-radio label="D"></el-radio></el-col>
                            <el-col :span="3"><el-radio label="E"></el-radio></el-col>
                            <el-col :span="3"><el-radio label="F"></el-radio></el-col>
                            <el-col :span="3"><el-radio label="G"></el-radio></el-col>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :lg="12">
                    <el-form-item v-mask="'#####'" :label="$labels.altitude" prop="altitude">
                        <el-input
                                v-model.number="post.altitude"
                                :placeholder="$labels.altitude">
                            <template slot="append">m</template>
                        </el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :lg="12">
                    <el-form-item :label="$labels.dpe_date_realisation" prop="dpe_date_realisation">
                        <el-date-picker
                                v-model="post.dpe_date_realisation"
                                :placeholder="$labels.dpe_date_realisation"
                                format="dd/MM/yyyy"
                                value-format="dd/MM/yyyy"
                                @change="checkDisplayDpe">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row v-if="displayDpeVierge == true">
                <el-col :lg="12">
                  <el-form-item :label="$labels.soumis_dpe">
                    <el-radio v-model="post.soumis_dpe" label="oui">{{ $t("general.yes") }}</el-radio>
                    <el-radio v-model="post.soumis_dpe" label="non">{{ $t("general.no") }}</el-radio>
                  </el-form-item>
                </el-col>
                <el-col :lg="12" v-if="post.soumis_dpe === 'oui'">
                    <el-form-item :label="$labels.dpe_vierge">
                        <el-radio v-model="post.dpe_vierge" label="oui">{{ $t("general.yes") }}</el-radio>
                        <el-radio v-model="post.dpe_vierge" label="non">{{ $t("general.no") }}</el-radio>
                    </el-form-item>
                </el-col>

                <el-col :lg="24">
                    <small>
                        {{ $t("posts.edit.virginDPEMessage") }}
                    </small>
                </el-col>
            </el-row>

            <br />
            <div v-if="displayNewDpe == true">
                <el-row>
                    <el-col :span="24">
                        <el-form-item :label="$labels.montant_depenses_energies_min" prop="montant_depenses_energies_min">
                            <el-input v-mask="'#####'" v-model.number="post.montant_depenses_energies_min" :placeholder="$labels.montant_depenses_energies_min" type="montant_depenses_energies_min">
                                <div slot="append">{{getDevise}}</div>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item :label="$labels.montant_depenses_energies_max" prop="montant_depenses_energies_max">
                            <el-input v-mask="'#####'" v-model.number="post.montant_depenses_energies_max" :placeholder="$labels.montant_depenses_energies_max" type="montant_depenses_energies_max">
                                <div slot="append">{{getDevise}}</div>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item :label="$labels.montant_depenses_energies_estime" prop="montant_depenses_energies_estime">
                            <el-input v-mask="'#####'" v-model.number="post.montant_depenses_energies_estime" :placeholder="$labels.montant_depenses_energies_estime" type="montant_depenses_energies_estime">
                                <div slot="append">{{getDevise}}</div>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :lg="8">
                        <el-form-item :label="$labels.annee_indice_prix_energies" prop="annee_indice_prix_energies">
                            <el-input v-model="post.annee_indice_prix_energies"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </div>
            <div v-else>
                <el-row>
                    <el-col :span="24">
                        <el-form-item :label="$labels.montant_depenses_energies_estime" prop="montant_depenses_energies_estime">
                            <el-input v-mask="'#####'" v-model.number="post.montant_depenses_energies_max" :placeholder="$labels.montant_depenses_energies_estime" type="montant_depenses_energies_estime">
                                <div slot="append">{{getDevise}}</div>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :lg="12">
                        <el-form-item :label="$labels.date_indice_prix_energies" prop="date_indice_prix_energies">
                            <el-date-picker
                                    v-model="post.date_indice_prix_energies"
                                    :placeholder="$labels.date_indice_prix_energies"
                                    format="dd/MM/yyyy"
                                    value-format="dd/MM/yyyy">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
            </div>
        </ubi-form-group>
    </ubi-panel>
</template>

<script>
import { getDefinitionDonneeListeeByCode } from '@/services/posts'
import moment from 'moment'
import UbiPanel from '../../../../components/Panel'
export default {
  name: 'DpeGes',
  components: { UbiPanel },
  props: ['post', 'ddList'],
  computed: {
    getDevise () {
      return this.$store.getters['donnees/getDevise']
    }
  },
  data () {
    return {
      displayDpeVierge: true,
      displayNewDpe: true
    }
  },
  methods: {
    checkDisplayDpe () {
      const formatDateDpe = moment(this.post.dpe_date_realisation, 'DD/MM/YYYY')
      const checkDateDpe2021 = moment(formatDateDpe).isBefore('2021-07-01')
      this.displayDpeVierge = checkDateDpe2021
      this.displayNewDpe = !this.post.dpe_date_realisation || !checkDateDpe2021
    }
  }
}
</script>

<style>

</style>
